

export const ClientDetails = () => {

    return (
        <div></div>
    )
}